import styled from "styled-components";
import { color, typeStyle, units } from "@m/alchemy-theme";
export const TooltipHeader = styled.h3 `
  ${typeStyle("bodyL")};
  margin: ${units(1)} ${units(0.5)} 0 ${units(0.5)};
`;
export const TooltipContent = styled.div `
  /* Header should not scroll, only popover content */
  overflow-y: auto;
  padding-right: ${units(1.5)};
  margin: ${units(2)} ${units(0.5)} 0 ${units(0.5)};
`;
export const TooltipFooter = styled.div `
  border-top: 1px solid ${color("line")};
  padding-top: ${units(2)};
  margin: ${units(2)} ${units(0.5)} ${units(0.5)} ${units(0.5)};
`;
